// fetchBaseQuery is the function that will allow us to make requests to our backend API.
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../constants';

import { logout } from './authSlice'; // Import the logout action

const baseQuery = fetchBaseQuery({
	baseUrl: BASE_URL,
	credentials: 'include', // 包含 cookies 和认证信息
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
	let result = await baseQuery(args, api, extraOptions);
	if (result.error && result.error.status === 401) {
		// 后端没有 refreshToken 路由，401 直接视为登录失效
		api.dispatch(logout());
	}
	return result;
};
async function baseQueryWithAuth(args, api, extra) {
	// 先尝试使用 baseQueryWithReauth 来处理 token 刷新
	let result = await baseQueryWithReauth(args, api, extra);

	// Dispatch the logout action only on 401 (unauthorized - authentication failed).
	// 403 (forbidden) means the user is authenticated but doesn't have permission,
	// so we should not logout the user, just show an error message.
	// 注意：baseQueryWithReauth 已经处理了 401 的情况，这里只处理刷新失败后的最终 401
	if (result.error && result.error.status === 401) {
		// baseQueryWithReauth 已经尝试刷新 token，如果还是 401，说明刷新失败或 token 无效
		// 此时应该登出用户
		api.dispatch(logout());
	}
	return result;
}

// endpoints is an object that will contain all of our API endpoints. We don't have to manually fetch data from our API anymore. We can just call the endpoints object and it will automatically fetch the data for us.
/** 订单列表/待办缓存；与 getOrderDetails 的 `{ type: 'Order', id }` 分开，避免流程写回后整单重拉详情 */
export const ORDER_LIST_TAG = { type: 'Order', id: 'LIST' };

export const apiSlice = createApi({
	baseQuery: baseQueryWithAuth, // Use the customized baseQuery
	baseQueryWithReauth: baseQueryWithReauth,
	tagTypes: ['Product', 'ProductBatch', 'Customer', 'Order', 'User', 'OrderDraft', 'Quotation', 'Approval', 'Notification', 'Brand', 'Supplier', 'PerformanceRule', 'StatisticsDashboardCharts', 'HomeDashboardCharts', 'HomeDashboardLayout', 'OrgDepartment', 'OrgGroup'],
	endpoints: (builder) => ({}),
});
